import { mapGetters } from 'vuex';
import { fileUploadAcceptString } from '../utils/constants';

export default {
  data() {
    return {
      fileList: [],
      currentFieldName: '',
      fileUploadAcceptString,
      fileUpdateUrl: `${process.env.VUE_APP_API_URL}/assemble/api/v1/admin/files/tmp`,
      isUploading: false,
      uploadPercentage: 0,
    };
  },
  methods: {
    beforeUpload(file) {
      const size = file.size / 1024 / 1024;
      if (size > 10) {
        this.$message.error('File size is more than 10mb');
        return false;
      }
      return true;
    },
    async handleChange(file) {
      if (!this.beforeUpload(file.raw)) return false;

      // Check for duplicate files
      if (this.fileList.some((f) => f.name === file.name)) {
        this.$message.error('File already exists');
        return false;
      }

      this.isUploading = true;
      const res = await this.$http.post(
        this.fileUpdateUrl,
        {
          fileName: file.name
        },
        {
          onUploadProgress: (progressEvent) => {
            this.uploadPercentage = Math.round((progressEvent.loaded / progressEvent.total) * 100);
          }
        }
      );
      const { url, name, s3Path } = res.data;

      await fetch(url, {
        method: 'PUT',
        body: file.raw,
        headers: { 'Content-Type': '*/*' },
      });

      this.fileList.push({
        name,
        url: s3Path
      });

      this.isUploading = false;

      return true;
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    }
  },
  computed: {
    accept() {
      return fileUploadAcceptString;
    },
    ...mapGetters('user', [
      'uploadHeaders',
    ]),
  },
};
